export function buildObtenerUsuarioResponse(obtenerUsuarioResponse) {
    return {
        usuarioDTO: obtenerUsuarioResponse.usuarioDTO,
        esRespOK: obtenerUsuarioResponse.respuestaOK,
        respCodigo: obtenerUsuarioResponse.codigoRespuesta,
        respMensaje: obtenerUsuarioResponse.mensajeRespuesta,
    }
}
